import { render } from "./DetailType.vue?vue&type=template&id=4d849dfa"
import script from "./DetailType.vue?vue&type=script&lang=js"
export * from "./DetailType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__